import { utc } from '@date-fns/utc';
import { format } from 'date-fns';
import { subMinutes } from 'date-fns/subMinutes';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm:ss`;

export function formatDateObjectToFormat(date: Date, formatString: string, options = {}) {
  return format(date, formatString, options);
}

export function formatDateObjectToFormatUTC(dateString: Date, formatString: string) {
  return formatDateObjectToFormat(dateString, formatString, { in: utc });
}

export function formatNowToDateStringUTC() {
  return formatDateObjectToFormatUTC(new Date(), DATE_FORMAT);
}

export function formatDateObjectToDateTimeStringUTC(date: Date) {
  return formatDateObjectToFormatUTC(date, DATE_TIME_FORMAT);
}

export function toInput(value: string) {
  if (!value) return value;
  return value.substring(0, 16);
}

export function transformToUtc(dateObject: Date) {
  const offsetInMinutes = dateObject.getTimezoneOffset();
  return subMinutes(dateObject, offsetInMinutes);
}

export function fromInput(value: string) {
  if (!value) return value;
  return `${value}:00.000Z`;
}
